:host {
  flex-grow: 1 !important;
}
